import React from 'react';
import { ReduxStore } from '@trip-ux/redux-store';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { sanitizeDOM } from '@trip-ux/common';
import './need-assistance.scss';

export const NeedAssistance = () => {
  const { cfm } = useSelector((store: ReduxStore) => ({
    cfm: store.contentFragment
  }));
  const wording = sanitizeDOM(get(cfm.needAssistance, 'text'))

  return (
    <>
      <div className="need-assistance-container" role="complementary">
        <div className="need-assistance border" dangerouslySetInnerHTML={{ __html: wording }} />
      </div>
    </>
  );
};
